import { MONITOR_OBJECT_OPTIONS } from './constants';
import { AlarmLevel, CreateRuleFormValues, DispatchDeviationAlarmRule, MonitorObjectType, RuleStatus } from './types';

const monitorObjects = [
  { type: MonitorObjectType.PV, name: '东南一号光伏站' },
  { type: MonitorObjectType.PV, name: '东南二号光伏站' },
  { type: MonitorObjectType.STORAGE, name: '一号储能站' },
  { type: MonitorObjectType.LOAD, name: '一号负荷中心' },
];

const alarmLevels = [
  AlarmLevel.LOW,
  AlarmLevel.HIGH,
  AlarmLevel.MEDIUM,
  AlarmLevel.MEDIUM,
  AlarmLevel.HIGHEST,
  AlarmLevel.HIGHEST,
  AlarmLevel.LOWEST,
];

let mockRules: DispatchDeviationAlarmRule[] = Array.from({ length: 32 }, (_, index) => {
  const monitorObject = monitorObjects[index % monitorObjects.length];
  const sequence = String(index + 1).padStart(3, '0');

  return {
    id: index + 1,
    code: `RU${String(1266971 + index)}`,
    name: `IV_20250912_${sequence}`,
    monitorObjectType: monitorObject.type,
    monitorObject: monitorObject.name,
    alarmLevel: alarmLevels[index % alarmLevels.length],
    status: index % 4 === 2 ? RuleStatus.DISABLED : RuleStatus.ENABLED,
    lastOperator: index % 3 === 0 ? 'administrator' : 'admin',
    lastOperationTime: `2025-09-${String(12 - (index % 8)).padStart(2, '0')} 16:${String(58 - (index % 20)).padStart(
      2,
      '0'
    )}:45`,
    monitorObjectIds: [MONITOR_OBJECT_OPTIONS[monitorObject.type][0]?.value].filter(Boolean) as string[],
    dispatchPoint: 'ACTIVE_POWER_SETPOINT',
    feedbackPoint: 'ACTIVE_POWER_FEEDBACK',
    monitoringDuration: 60,
    deviationRate: 5,
  };
});

export const getMockRules = () => [...mockRules];

export const getMockRule = (id: number) => mockRules.find(item => item.id === id);

const getRuleFormFields = (values: CreateRuleFormValues) => {
  const objectOptions = MONITOR_OBJECT_OPTIONS[values.monitorObjectType];
  const objectNames = values.monitorObjectIds.map(
    value => objectOptions.find(option => option.value === value)?.label ?? value
  );

  return {
    name: values.name,
    monitorObjectType: values.monitorObjectType,
    monitorObject: objectNames.join('、'),
    alarmLevel: values.alarmLevel,
    monitorObjectIds: values.monitorObjectIds,
    dispatchPoint: values.dispatchPoint,
    feedbackPoint: values.feedbackPoint,
    monitoringDuration: values.monitoringDuration,
    deviationRate: values.deviationRate,
  };
};

const getCurrentTime = () => {
  const now = new Date();
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(
    now.getMinutes()
  )}:${pad(now.getSeconds())}`;
};

export const createMockRule = (values: CreateRuleFormValues) => {
  mockRules = [
    {
      id: Date.now(),
      code: `RU${String(Date.now()).slice(-7)}`,
      ...getRuleFormFields(values),
      status: RuleStatus.ENABLED,
      lastOperator: 'administrator',
      lastOperationTime: getCurrentTime(),
    },
    ...mockRules,
  ];
};

export const updateMockRule = (id: number, values: CreateRuleFormValues) => {
  mockRules = mockRules.map(item =>
    item.id === id
      ? {
          ...item,
          ...getRuleFormFields(values),
          lastOperator: 'administrator',
          lastOperationTime: getCurrentTime(),
        }
      : item
  );
};
